var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLifeAndPeopleMask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-2352.000000, -1978.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Life-and-people/Mask",
    transform: "translate(2352.000000, 1978.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0004,7.9999 C16.0004,7.9999 20.2584,10.5549 25.7314,11.8599 L25.7314,11.8599 L25.7324,11.8599 L25.7324,12.2399 C25.6444,18.8389 20.6754,24.0339 16.0004,24.9999 C11.3244,24.0339 6.3554,18.8389 6.2684,12.2399 L6.2684,12.2399 L6.2684,11.8599 C11.52252,10.6071 15.6577392,8.2023 15.9801517,8.01192048 Z M3.5395,11.7769 C3.6915,11.7769 3.8455,11.7839 4.0005,11.7999 L4.0005,11.7999 L4.2685,11.8139 L4.2685,12.2669 C4.2745,12.7929 4.3155,13.3089 4.3765,13.8189 C4.1825,13.8069 3.9865,13.8089 3.7945,13.7899 C3.7095,13.7809 3.6235,13.7769 3.5395,13.7769 C3.0765,13.7769 2.0005,13.9149 2.0005,15.1949 C2.0005,16.8039 3.5885,17.9599 5.8345,18.7559 C6.2795,19.6589 6.8145,20.5019 7.4085,21.2869 C3.6145,20.3999 0.000499999998,18.6499 0.000499999998,15.1949 C0.000499999998,13.0129 1.6355,11.7769 3.5395,11.7769 Z M28.4609,11.7764 C30.3639,11.7764 31.9999,13.0134 31.9999,15.1954 C31.9999,18.6494 28.3849,20.3994 24.5919,21.2874 C25.1859,20.5024 25.7209,19.6604 26.1659,18.7554 C28.4109,17.9614 29.9999,16.8034 29.9999,15.1954 C29.9999,13.9144 28.9239,13.7764 28.4609,13.7764 C28.3769,13.7764 28.2909,13.7804 28.2049,13.7894 C28.0139,13.8094 27.8169,13.8064 27.6239,13.8194 C27.6839,13.3094 27.7249,12.7924 27.7319,12.2664 L27.7319,12.2664 L27.7319,11.8134 C27.8219,11.8064 27.9089,11.8094 27.9999,11.7994 C28.1549,11.7844 28.3089,11.7764 28.4609,11.7764 Z",
    id: 283
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLifeAndPeopleMask);
export default __webpack_public_path__ + "static/media/life-and-people-mask.6cbf3df0.svg";
export { ForwardRef as ReactComponent };